<template>
  <v-container>
    <v-row class="text-center">
      <!-- <v-col cols="12">
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        />
      </v-col> -->
      <v-col cols="12"></v-col>
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Advanced Mouse Sensitivity Converter
        </h1>

        <!-- <p class="subheading font-weight-regular">
          Mouse Sensitivity Converter / Calculator
        </p> -->
      </v-col>

      <v-col cols="12">
        <v-row justify="space-around">
          <v-col class="d-flex" cols="12" sm="5">
            <v-select
              :items="convModes"
              label="Convert Mode"
              v-model="mode"
              @change="onConvModeSet"
              outlined
            ></v-select>
          </v-col>

          <v-col class="d-flex" cols="12" sm="5">
            <v-slider
              :label="slideLabel"
              class="align-center"
              :max="200"
              :min="1"
              v-model="dist"
              :disabled="slideDisable"
              @input="convert"
            >
              <template v-slot:append>
                <v-text-field
                  class="mt-0 pt-0"
                  outlined
                  dense
                  single-line
                  type="number"
                  style="width: 80px"
                  v-model="dist"
                  :disabled="slideDisable"
                ></v-text-field>
              </template>
            </v-slider>
          </v-col>
        </v-row>

        <v-divider />
        <p />
        <h2 class="display-1 font-weight-bold mb-3">Convert From</h2>
        <p />

        <v-row justify="start">
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="screenRT"
              :label="screenRTLabel"
              :disabled="screenRTDisable"
              v-model="game1Data.screenRT"
              item-text="text"
              item-value="value"
              @change="onScreenRTSet"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :disabled="szDisable"
              :label="szLabel"
              v-model="game1Data.screenSZ"
              @input="onScreenSzSet"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="gameRT"
              :label="gameRTLabel"
              :disabled="gameRTDisable"
              v-model="game1Data.gameRT"
              item-text="text"
              item-value="value"
              @change="onGameRTSet"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              label="DPI"
              v-model="game1Data.dpi"
              @input="onDPISet"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="games"
              label="Game"
              v-model="game1Data.game"
              @change="onGame1Set"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              label="Mode"
              v-model="game1Data.mode"
              :items="gameInfo1.modes"
              @change="onGame1ModeSet"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="fovLabel"
              :disabled="game1Layout.fovDisable"
              v-model="game1Data.fov"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game1Layout.dt1Label"
              :disabled="game1Layout.dt1Disable"
              :readonly="game1Layout.dt1RO"
              v-model="game1Data.val1"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game1Layout.dt2Label"
              :disabled="game1Layout.dt2Disable"
              :readonly="game1Layout.dt2RO"
              v-model="game1Data.val2"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game1Layout.dt3Label"
              :disabled="game1Layout.dt3Disable"
              :readonly="game1Layout.dt3RO"
              v-model="game1Data.val3"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="5" sm="2">
            <v-select
              :items="game1Layout.op1Item"
              :label="game1Layout.op1Label"
              :disabled="game1Layout.op1Disable"
              v-model="game1Data.op1"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="5" sm="2">
            <v-select
              :items="game1Layout.op2Item"
              :label="game1Layout.op2Label"
              :disabled="game1Layout.op2Disable"
              v-model="game1Data.op2"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-divider />
        <p />
        <h2 class="display-1 font-weight-bold mb-3">Convert To</h2>
        <p />

        <v-row justify="start">
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="screenRT"
              :label="screenRTLabel"
              :disabled="screenRTDisable"
              v-model="game2Data.screenRT"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :disabled="szDisable"
              :label="szLabel"
              v-model="game2Data.screenSZ"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="gameRT"
              :label="gameRTLabel"
              :disabled="gameRTDisable"
              v-model="game2Data.gameRT"
              item-text="text"
              item-value="value"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              label="DPI"
              v-model="game2Data.dpi"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="games"
              label="Game"
              v-model="game2Data.game"
              @change="onGame2Set"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              label="Mode"
              :items="gameInfo2.modes"
              v-model="game2Data.mode"
              @change="onGame2ModeSet"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="fovLabel"
              :disabled="game2Layout.fovDisable"
              v-model="game2Data.fov"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game2Layout.dt1Label"
              :disabled="game2Layout.dt1Disable"
              :readonly="game2Layout.dt1RO"
              v-model="game2Data.val1"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game2Layout.dt2Label"
              :disabled="game2Layout.dt2Disable"
              :readonly="game2Layout.dt2RO"
              v-model="game2Data.val2"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-text-field
              :label="game2Layout.dt3Label"
              :disabled="game2Layout.dt3Disable"
              :readonly="game2Layout.dt3RO"
              v-model="game2Data.val3"
              @input="convert"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="5" sm="2">
            <v-select
              :items="game2Layout.op1Item"
              :label="game2Layout.op1Label"
              :disabled="game2Layout.op1Disable"
              v-model="game2Data.op1"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="5" sm="2">
            <v-select
              :items="game2Layout.op2Item"
              :label="game2Layout.op2Label"
              :disabled="game2Layout.op2Disable"
              v-model="game2Data.op2"
              @change="convert"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="8">
            <InnerLink></InnerLink>
          </v-col>
        </v-row>
        <!-- <v-row justify="center">
          <v-col cols="12" sm="8">
            <v-card outlined>
              <v-card-title class="display-1">使用说明</v-card-title>
              <v-card-text class="title text-left">
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;鼠标灵敏度转换器用于将源游戏的鼠标灵敏度转换为目标游戏的鼠标灵敏度（鼠标灵敏度一般可以在游戏设置中找到），
                  使用时用户需要在源游戏参数区域和目标游戏参数区域分别填写各项参数，转换结果将会在目标游戏参数的对应项目实时更新。
                </p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;在转换前您需要选定灵敏度转换模式，这里推荐使用等比转换。舒适拉枪距离意为您习惯的准星距离目标的距离，在等比转换模式下表示这一距离占半个屏幕宽度的百分比，
                  在等距转换模式下表示这一距离的实际厘米数。
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InnerLink from "./InnerLink.vue";
import {
  ConvModes,
  Games,
  ScreenRatio,
  GameRatio,
  GameInfo,
  GetRatio,
} from "../conv.js";

export default {
  name: "SensAdv",
  components: {
    InnerLink,
  },
  metaInfo: {
    title:
      "Advanced Mouse Sensitivity Converter: A Free To Use FPS Game Utility", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "Mouse Sensitivity Converter, \
          Mouse Sensitivity calculator, \
          game Sensitivity Converter, \
          game Sensitivity calculator, \
          sens converter, \
          sense converter, \
          sensitivity calculator, \
          sens calculator, \
          APEX,\
          counter strike,\
          overwatch\
          ",
      },
      {
        // set meta
        name: "description",
        content:
          "This website is used to convert(calculate) the mouse sensitivity between different games. This tool is free to use, and will be updated continuously.",
      },
    ],
    link: [
      {
        // set link
        rel: "asstes",
        href: "http://fpshelper.com/en/advanced/",
      },
    ],
  },
  methods: {
    clearGameLayout: function (layout, data) {
      layout.dt1Label =
        layout.dt2Label =
        layout.dt3Label =
        layout.op1Label =
        layout.op2Label =
          "No Need To Input";
      layout.op1Item = [];
      layout.op2Item = [];
      layout.fovDisable =
        layout.dt1Disable =
        layout.dt2Disable =
        layout.dt3Disable =
        layout.op1Disable =
        layout.op2Disable =
          true;
      layout.dt1RO = layout.dt2RO = layout.dt3RO = false;
      data.screenRT =
        data.screenSZ =
        data.gameRT =
        data.dpi =
        data.fov =
        data.game =
        data.mode =
          "";
      data.val1 = data.val2 = data.val3 = "";
      data.op1 = data.op2 = "";
    },

    clearLayout: function () {
      this.clearGameLayout(this.game1Layout, this.game1Data);
      this.clearGameLayout(this.game2Layout, this.game2Data);
    },

    onConvModeSet: function () {
      this.clearLayout();

      if (this.mode == "Convert With Same Ratio(recommended)") {
        this.slideLabel = "Comfortable Distance(%)";
        this.slideDisable = false;
        this.dist = 25;
      } else if (this.mode == "Convert With Same Distance") {
        this.slideLabel = "Comfortable Distance(cm)";
        this.slideDisable = false;
        this.dist = 5;
      } else {
        this.slideLabel = "No Need To Input";
        this.slideDisable = true;
      }

      if (this.mode != "Convert With Same Angle") {
        this.screenRTLabel = "Screen Aspect Ratio";
        this.gameRTLabel = "Game Aspect Ratio";
        // this.fovLabel = "FOV";
        this.screenRTDisable = this.gameRTDisable = false;
      } else {
        this.screenRTLabel = this.gameRTLabel = "No Need To Input";
        this.screenRTDisable = this.gameRTDisable = true;
      }

      if (this.mode != "Convert With Same Distance") {
        this.szLabel = "No Need To Input";
        this.szDisable = true;
      } else {
        this.szLabel = "Screen Size(inch)";
        this.szDisable = false;
      }
    },
    onScreenRTSet: function () {
      this.game2Data.screenRT = { ...this.game1Data.screenRT };
      this.convert();
    },
    onScreenSzSet: function () {
      this.game2Data.screenSZ = this.game1Data.screenSZ;
      this.convert();
    },
    onGameRTSet: function () {
      this.game2Data.gameRT = { ...this.game1Data.gameRT };
      this.convert();
    },
    onDPISet: function () {
      this.game2Data.dpi = this.game1Data.dpi;
      this.convert();
    },
    onGame1Set: function () {
      this.gameInfo1 = GameInfo[this.game1Data.game];
      this.game1Data.mode = this.gameInfo1.modes[0];
      this.gameInfo1.onModeSet(this.game1Layout, this.game1Data, true);
      this.convert();
    },
    onGame1ModeSet: function () {
      this.gameInfo1.onModeSet(this.game1Layout, this.game1Data, true);
      this.convert();
    },
    onGame2Set: function () {
      this.gameInfo2 = GameInfo[this.game2Data.game];
      this.game2Data.mode = this.gameInfo2.modes[0];
      this.gameInfo2.onModeSet(this.game2Layout, this.game2Data, false);
      this.convert();
    },
    onGame2ModeSet: function () {
      this.gameInfo2.onModeSet(this.game2Layout, this.game2Data, false);
      this.convert();
    },

    convert: function () {
      if (!this.gameInfo1.calcSens || !this.gameInfo2.calcSens) return;
      if (this.mode == "Convert With Same Angle") {
        this.gameInfo2.calcSens(
          this.gameInfo1.getSpeed(this.game1Data),
          this.game2Data
        );
        return;
      }
      let k1 = GetRatio(
        this.mode == "Convert With Same Distance",
        this.dist,
        this.game1Data
      );
      let deg1 = Math.atan(k1 * this.gameInfo1.getTanFOV(this.game1Data));
      let k2 = GetRatio(
        this.mode == "Convert With Same Distance",
        this.dist,
        this.game2Data
      );
      let deg2 = Math.atan(k2 * this.gameInfo2.getTanFOV(this.game2Data));
      this.gameInfo2.calcSens(
        (this.gameInfo1.getSpeed(this.game1Data) * deg2) / deg1,
        this.game2Data
      );
    },
  },
  data: () => ({
    games: Games,
    convModes: ConvModes,
    screenRT: ScreenRatio,
    gameRT: GameRatio,
    mode: "Convert With Same Ratio(recommended)",
    slideLabel: "Comfortable Distance(%)",
    slideDisable: false,
    dist: 25,

    screenRTLabel: "Screen Aspect Ratio",
    szLabel: "No Need To Input",
    gameRTLabel: "Game Aspect Ratio",
    fovLabel: "FOV",
    screenRTDisable: false,
    szDisable: true,
    gameRTDisable: false,

    gameInfo1: {},
    gameInfo2: {},

    game1Layout: {
      dt1Label: "No Need To Input",
      dt2Label: "No Need To Input",
      dt3Label: "No Need To Input",
      op1Label: "No Need To Input",
      op2Label: "No Need To Input",
      op1Item: [],
      op2Item: [],
      fovDisable: true,
      dt1Disable: true,
      dt2Disable: true,
      dt3Disable: true,
      op1Disable: true,
      op2Disable: true,
      dt1RO: true,
      dt2RO: true,
      dt3RO: true,
    },
    game1Data: {
      screenRT: "",
      screenSZ: "",
      gameRT: "",
      dpi: "",
      fov: "",
      game: "",
      mode: "",
      val1: "",
      val2: "",
      val3: "",
      op1: "",
      op2: "",
    },
    game2Layout: {
      dt1Label: "No Need To Input",
      dt2Label: "No Need To Input",
      dt3Label: "No Need To Input",
      op1Label: "No Need To Input",
      op2Label: "No Need To Input",
      op1Item: [],
      op2Item: [],
      fovDisable: true,
      dt1Disable: true,
      dt2Disable: true,
      dt3Disable: true,
      op1Disable: true,
      op2Disable: true,
      dt1RO: true,
      dt2RO: true,
      dt3RO: true,
    },
    game2Data: {
      screenRT: "",
      screenSZ: "",
      gameRT: "",
      dpi: "",
      fov: "",
      game: "",
      mode: "",
      val1: "",
      val2: "",
      val3: "",
      op1: "",
      op2: "",
    },
  }),
  computed: {},
};
</script>
